// extracted by mini-css-extract-plugin
export var avatar = "_ox-3";
export var avatarContainer = "_ox-2";
export var avatarSpacer = "_ox-5";
export var avatarSpacerContainer = "_ox-4";
export var avatarStackContainer = "_ox-1";
export var bubble = "_ox-0";
export var remainderBubble = "_ox-6";